import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_FAVORITED_ANALYSES } from '../graphql/queries';
import {
  IGetFavoritedAnalysesQuery,
  IGetFavoritedAnalysesQueryVariables,
  IPagination,
} from '../../../utils/apollo/graphqlSchema';
import { ContentLoader } from '../../../components/Loaders';
import FavoritedReportsEmptySlide from './FavoritedReportsEmptySlide';
import FavoritedReportsSlider from './FavoritedReportsSlider';
import { useAppDispatch } from '../../../redux/hooks';
import { setLoadingAnalysesInStoreAction } from '../../../redux/slices/loadingAnalyses';

const queryPagination: IPagination = {
  first: 0,
  after: 0,
};

const FavoritedReportsContent = () => {
  const dispatch = useAppDispatch();

  const handleLoadReports = ({
    searchAnalysis,
  }: IGetFavoritedAnalysesQuery) => {
    const entities = searchAnalysis?.entities;

    if (entities && entities.length > 0) {
      dispatch(
        setLoadingAnalysesInStoreAction({
          analysisIds: entities.map((entity) => entity.id),
          refresh: false,
        }),
      );
    }
  };

  const { data, loading } = useQuery<
    IGetFavoritedAnalysesQuery,
    IGetFavoritedAnalysesQueryVariables
  >(GET_FAVORITED_ANALYSES, {
    variables: {
      userOnly: false,
      schemaIds: [],
      kind: null,
      queryTypes: [],
      term: null,
      statuses: [],
      includes: [],
      filter: null,
      favoriteOnly: true,
      pagination: queryPagination,
    },
    onCompleted: handleLoadReports,
  });

  if (loading) {
    return <ContentLoader />;
  }

  const entities = data?.searchAnalysis?.entities;

  if (!entities?.length) {
    return <FavoritedReportsEmptySlide />;
  }

  return <FavoritedReportsSlider entities={entities} />;
};

export default FavoritedReportsContent;
